<!--
 * @Descripttion: 
 * @version: 
 * @Author: mrh
 * @Date: 2020-07-28 09:29:22
 * @LastEditors: mrh
 * @LastEditTime: 2021-01-06 17:54:15
--> 
<template>
  <div
    class="divs"
    :class="{'cover':!$store.getters.ambientType}"
  >
    <div class="tip">
      <span>提示:系统没有您{{csType == 1 ? "居住" : "想要"}}的{{csType == 1 ? "社" : "校"}}区吗？您可以在当前页面申请开通{{csType == 1 ? "社" : "校"}}区</span>
    </div>
    <van-form
      validate-first
      @failed="onFailed"
      :show-error-message="false"
      scroll-to-error
      ref="submits"
      @submit="onSubmit"
      :show-error="showError"
    >
      <van-field
        v-model="communiyObj.areaIds"
        label="开通城市"
        :placeholder="`请选择${csType == 1 ? '社' : '校'}区城市`"
        readonly
        required
        right-icon="arrow"
        @click="showArea = true"
        :rules="[{ validator: asyncValidator, message: `请选择${csType == 1 ? '社' : '校'}区城市`, trigger:onSubmit }]"
      />
      <van-field
        v-model="communiyObj.areaBCIds"
        :label="`${csType == 1 ? '社' : '校'}区商圈`"
        :placeholder="`请选择${csType == 1 ? '社' : '校'}区商圈`"
        right-icon="arrow"
        @click="showList = true"
        readonly
        required
        :rules="[{ validator: asyncValidator, message: `请选择${csType == 1 ? '社' : '校'}区商圈`, trigger:onSubmit }]"
      />
      <van-field
        v-model="communiyObj.schoolName"
        :label="`${csType == 1 ? '社' : '校'}区类型`"
        :placeholder="`请选择${csType == 1 ? '社' : '校'}区类型`"
        right-icon="arrow"
        @click="showSchoolList = true;"
        readonly
        required
        :rules="[{ validator: asyncValidator, message: `请选择${csType == 1 ? '社' : '校'}区类型`, trigger:onSubmit }]"
        v-if="csType == 2"
      />
      <van-field
        v-model="communiyObj.communiytName"
        :label="`${csType == 1 ? '社' : '校'}区名称`"
        :placeholder="`请输入${csType == 1 ? '社' : '校'}区全称`"
        @click="showEditPopup()"
        readonly
        required
        :rules="[{ validator: asyncValidator, message: `请输入${csType == 1 ? '社' : '校'}区全称`, trigger:onSubmit }]"
      />
      <van-field
        v-model="communiyObj.address"
        label="详细地址"
        :placeholder="`请选择${csType == 1 ? '社' : '校'}区详情地址`"
        readonly
        required
        @click="goCheckAddress"
        right-icon="arrow"
        :rules="[{ validator: asyncValidator, message: `请选择${csType == 1 ? '社' : '校'}区详情地址`, trigger:onSubmit }]"
      />
      <div class="btns">
        <van-button
          round
          block
          type="info"
          native-type="button"
          @click="confirm()"
          color="#50BE4C"
        >提交申请</van-button>
      </div>
    </van-form>
    <div class="tipText">
      <span>提示：</span>
      <span>
        <p>若已有{{csType == 1 ? "社" : "校"}}区与您申请{{csType == 1 ? "社" : "校"}}区信息不符，可以联系平台客服进行修改<a
            @click="dialPhone('0752-2162293')"
            style="color: #50BE4C"
          >0752-2162293</a></p>
      </span>
    </div>
    <!-- 选择城市弹窗 -->
    <van-popup
      v-model="showArea"
      :overlay="showArea"
      ref="popup"
      position="bottom"
      :style="{ height: '68%' }"
    >
      <van-area
        ref="area"
        :area-list="areaList"
        :value="areaId"
        visible-item-count="9"
        @confirm="checkArea"
        @cancel="showArea = false"
      />
    </van-popup>
    <!-- 校区类型弹窗 -->
    <van-popup
      v-model="showSchoolList"
      position="bottom"
    >
      <van-picker
        show-toolbar
        value-key="name"
        :columns="schoolList"
        @confirm="onConfirm"
        @cancel="showSchoolList = false"
      />
    </van-popup>
    <!-- 商圈弹窗 -->
    <van-popup
      v-model="showList"
      position="bottom"
      :style="{ height: '68%', overflow: 'hidden' }"
    >
      <div class="listdiv">
        <p
          v-for="(item, index) in circleList"
          :key="index"
          class="adlists"
          :class="{ listcol: index == circleIndex }"
          @click="confirmList(item, index)"
        >
          <span>{{ item.areaCircleName }}</span>
        </p>
      </div>
    </van-popup>
    <!-- 社/校区名称弹窗 -->
    <van-dialog
      :title="`${csType == 1 ? '社' : '校'}区名称`"
      v-model="showEdit"
      show-cancel-button
      confirmButtonColor="#50BE4C"
      cancelButtonColor="#606266"
      :before-close="beforeClose"
      :lazy-render="false"
    >
      <van-field
        ref="editCommuniytName"
        class="deliverySet-field"
        v-model="editCommuniytName"
        :placeholder="`请输入您要新增的${csType == 1 ? '社' : '校'}区名称`"
        :error-message="message"
        input-align="center"
        error-message-align="center"
        maxlength="50"
      >
      </van-field>
    </van-dialog>
  </div>
</template>

<script>
import {
  getBusinesscCircleList,
  searchCsList
} from "@/api/join";
import areaLists from "@/utils/area.js";
export default {
  data() {
    return {
      communiyObj: {
        communityId: "0", // 社/校区id
        communiytName: "", // 社/校区名
        areaIds: "", // 社/校区所在地区ID
        areaBCIds: "", // 地区商圈ID，传0则说明没有商圈
        address: "", // 详细地址
        // mobile: "", // 联系电话
        longitude: "", // 经度
        latitude: "", // 纬度
        schoolName: "", // 校区类型名称
      },
      showError: false,
      areaId: "", // 区id
      areaBCId: "", // 商圈id
      areaList: areaLists, // 省市区list
      showArea: true, // 是否展示省市区选择列表
      city: "", // 城市名
      cityId: "", // 城市id
      circleList: [], // 附近商圈list
      showList: false, // 商圈/校区类型弹窗
      circleIndex: 0, // 附近商圈list的index
      lng: "", //经度
      lat: "", //纬度
      csType: 1, // 1社区，2校区
      showEdit: false, // 显示社/校区名称弹窗
      message: "", // 社/校区名称错误提示
      editCommuniytName: "", // 编辑社/校区名称
      schoolType: 0, // 校区类型id
      schoolList: [{
        id: 1,
        name: "幼儿园",
      }, {
        id: 2,
        name: "小学",
      }, {
        id: 3,
        name: "中学",
      }, {
        id: 4,
        name: "其他",
      }],
      type: 0, // 0.商圈列表 1.校区列表
      showSchoolList: false
    };
  },
  mounted() {
    this.csType = this.$route.query.csType * 1 || 1;
    this.areaId =
      this.$store.getters.areaId == "-1"
        ? "441302"
        : this.$store.getters.areaId;
    // 选择省市区
    this.$refs.area.reset(this.areaId);
    this.showArea = false;
    //通过实例的getValues获取选中的列表
    let a = this.$refs.area.getValues();
    this.communiyObj.areaIds = `${a[0].name}/${a[1].name}/${a[2].name}`;
    this.city = a[1].name;
    this.cityId = a[1].code;
    this.getBusinesscCircleList(this.areaId);
  },
  methods: {
    onConfirm(value) {
      this.communiyObj.schoolName = value.name;
      this.schoolType = value.id;
      this.showSchoolList = false;
    },
    // 打开社/校区名称弹窗
    showEditPopup() {
      this.showEdit = true;
      setTimeout(() => {
        this.$refs.editCommuniytName.focus();
      }, 250)
    },
    // 整理数据 传值给APP
    organizeData() {
      if (this.$store.getters.ambientType == 1) {
        window.Android.jumpApplyCs(
          this.communiyObj.communityId.toString(),
          this.communiyObj.communiytName,
          this.areaId.toString(),
          this.areaBCId.toString(),
          this.communiyObj.address,
          this.lng.toString(),
          this.lat.toString(),
          this.schoolType.toString()
        );
      } else if (this.$store.getters.ambientType == 2) {
        window.webkit.messageHandlers.jumpApplyCs.postMessage({
          communityId: this.communiyObj.communityId,
          communiytName: this.communiyObj.communiytName,
          areaId: this.areaId,
          areaBCId: this.areaBCId,
          address: this.communiyObj.address,
          longitude: this.lng,
          latitude: this.lat,
          schoolType: this.schoolType
        });
      }
    },
    beforeClose(action, done) {
      switch (action) {
        case 'confirm':
          if (this.editCommuniytName.trim() == "") {
            this.message = `请输入${this.csType == 1 ? '社' : '校'}区名称`;
            done(false);
            return;
          }
          searchCsList({
            position: {
              longitude: this.lng,
              latitude: this.lat,
            },
            cityId: this.cityId,//城市ID	
            keyword: this.editCommuniytName,//社区关键字	
            page: {
              way: "0", // 0:不分页 1:分页
              index: "1", //请求页
              size: "20",//请求大小
            },
          }).then(res => {
            // 筛选列表是否有相同名称社/校区
            let list = res.content.list.filter(item => item.shopName === this.editCommuniytName);
            if (list.length) {
              done();
              // 有相同名称社/校区 判断这个社/校区是否有店长
              let csName = this.csType == 1 ? '社' : '校';
              let message = list[0].state == 0 ? `此${csName}区已存在，无需新增，是否确定申请成为该${csName}区店长` : `该${csName}区已有正店长，无法再绑定，请选择其他${csName}区进行绑定`
              this.$dialog.alert({
                title: "温馨提示",
                message: message,
                overlay: false,
                showCancelButton: true,
                confirmButtonText: "确认",
                cancelButtonText: "取消",
                confirmButtonColor: "#50BE4C",
                cancelButtonColor: "#606266",
              })
                .then(() => {
                  // 社/校区有店长 则把社/校区名称和id传给APP端 没有店长 则把空值传给APP端
                  this.communiyObj.communiytName = list[0].shopName;
                  this.communiyObj.communityId = list[0].communityId;
                  // 调用APP方法
                  this.organizeData();
                })
            } else {
              // 没有相同名称社/校区 则直接新增
              this.showEdit = false;
              this.communiyObj.communiytName = this.editCommuniytName;
              done();
            }
          })
          break;
        case 'cancel':
          this.message = "";
          done();
          break;
      }
    },
    dialPhone(phone) {
      if (this.$store.getters.ambientType != 1) {
        window.location.href = 'tel:' + phone;
      } else {
        window.Android.dialPhone(phone);
      }
    },
    // 异步校验函数返回 Promise
    confirm() {
      this.clicks = true;
      this.$refs.submits.submit();
    },
    asyncValidator(val) {
      return new Promise((resolve) => {
        // this.$toast('校验保存中...')
        setTimeout(() => {
          this.$toast.clear();
          resolve(/\S/.test(val));
        }, 100);
      });
    },
    onSubmit() {
      // 调用APP方法
      this.organizeData();
    },
    onFailed(errorInfo) {
      this.$toast(errorInfo.errors[0].message);
      this.showError = true;
    },
    checkArea(a) {
      this.showArea = false;
      this.communiyObj.areaIds = `${a[0].name}/${a[1].name}/${a[2].name}`;
      this.areaId = a[2].code;
      this.city = a[1].name;
      this.getBusinesscCircleList(a[2].code);
    },
    goCheckAddress() {
      this.$router.push({
        path: "/map",
        query: {
          city: this.city,
          lng: this.$store.getters.longitude,
          lat: this.$store.getters.latitude,
        },
      });
    },
    getAreaCircle(item, index) {
      this.circleIndex = index;
    },
    confirmList(el, index) {
      this.communiyObj.areaBCIds = el.areaCircleName;
      this.areaBCId = el.areaCircleId;
      this.circleIndex = index;
      this.showList = false;
    },
    getBusinesscCircleList(areaId) {
      getBusinesscCircleList({ areaId }).then((res) => {
        this.circleList = res.content.circleList;
      });
    },
  },
  activated() {
    this.communiyObj.address = this.$route.query.address || "";
    this.lng = this.$route.query.lng;
    this.lat = this.$route.query.lat;
  },
  beforeRouteEnter(to, from, next) {
    if (to.query.csType) {
      to.meta.title = `开通${to.query.csType == 1 ? "社" : "校"}区`;
      document.title = to.meta.title;
    }
    next();
  },
};
</script>
<style lang="scss" scoped>
.btns {
  width: 355px;
  position: fixed;
  bottom: 10px;
  left: 0;
  right: 0;
  margin: 0 auto;
  .van-button {
    height: 40px;
    line-height: 40px;
    .van-button__text {
      font-size: 16px;
    }
  }
}
.divs {
  background: #f5f5f5;
  height: calc(100% - 44px);
}
.van-cell {
  line-height: 30px;
  /deep/.van-field__label {
    width: 75px;
    margin: 0;
  }
}
.van-cell--required::before {
  font-weight: 800;
  color: #ff2727;
}
.listdiv {
  height: calc(100% - 49px);
  overflow: auto;
}
.listcol {
  position: relative;
  span {
    color: #ff1310 !important;
  }
  span::before {
    content: "";
    width: 4px;
    height: 29px;
    background: #ff3838;
    position: absolute;
    left: 0;
    top: 15.5px;
  }
}

.adlists {
  width: auto;
  padding: 0 20px;
  height: 60px;
  display: flex;
  align-items: center;
  span {
    font-size: 16px;
    color: #333333;
  }
}
.cover {
  .seachList {
    top: 166px;
  }
}
.tipText {
  width: auto;
  margin: 10px 15px;
  span {
    font-size: 12px;
    color: #999;
    display: block;
    line-height: 18px;
  }
}
.tip {
  width: auto;
  height: 30px;
  padding: 0 15px;
  background: #ffe9d5;
  color: #333;
  font-size: 12px;
  line-height: 30px;
}
.deliverySet-field {
  padding: 8px 30px 27px;
  font-size: 16px;
}
</style>
<style scoped>
.deliverySet-field >>> .van-field__label {
  width: auto;
  height: 40px;
  line-height: 40px;
  margin-right: 5px;
  font-size: 15px;
  color: #1d1d1d;
}
.deliverySet-field >>> .van-field__control {
  padding: 7px 5px;
  border: 1px solid #b4b4b4;
  border-radius: 5px;
}
.deliverySet-field >>> .van-field__button {
  font-size: 15px;
  color: #1d1d1d;
}
.deliverySet-field >>> .van-field__error-message {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  font-size: 11px;
  color: #fd3325;
  z-index: 1000;
}
</style>